import React, { useEffect, useRef } from "react";
import Sticky from "react-stickynode";
import appShellUiVars from "_c/AppShell/ui-vars";
import PT from "prop-types";

const boundary = "#search-sticky-boundary";
const StickyAside = (props) => {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      ref.current.updateInitialDimension();
    }
  }, [props.resultsLength]);
  return (
    <Sticky
      ref={ref}
      bottomBoundary={boundary}
      enabled={props.isDesktop}
      top={parseInt(appShellUiVars.headDesktopHeight)}
    >
      {props.children}
    </Sticky>
  );
};
StickyAside.propTypes = {
  isDesktop: PT.bool,
  resultsLength: PT.number,
};

export default StickyAside;
